import React from 'react';

const SparePartsKeys_ProductListItem = ({
  availability,
  sparePart,
  getAddToCartButton,
  priceElement,
  deliveryDate,
  unavailabilityMessage,
  translations,
  isKeysAndLocks,
}) => {
  const isExtranet = _THULEDATA.SitecoreSiteName === 'Extranet';
  return (
    <div className="w-100 spm__productListItem p-0">
      <p className="heading6 m-0 py-4">
        {!isKeysAndLocks && sparePart.Badge && <span>{sparePart.Badge}. </span>}
        <a className="productName" target="_blank" href={sparePart.Url} rel="noreferrer">
          {sparePart.Name}
        </a>
      </p>
      <div className="d-flex flex-column align-items-start paragraph--s mb-4">
        <div className="paragraph--s mb-4 itemContent">
          <span className="text-color--gray80">{translations.ArticleNumber}</span> {sparePart.Id}
        </div>
        {unavailabilityMessage ? (
          <div className="paragraph--s mb-4 itemContent">
            <span className="text-color--gray80 w-100">{unavailabilityMessage}</span>
          </div>
        ) : (
          <>
            <div className="paragraph--s mb-4 itemContent">
              <span className="text-color--gray80">
                {isExtranet ? `${translations.Price}/${translations.RRP}` : translations.Price}
              </span>
              {priceElement}
            </div>
            {deliveryDate && (
              <div className="paragraph--s mb-4 itemContent">
                <span className="text-color--gray80">{translations?.Available}</span>
                <div>
                  {availability && <span className="me-4">{availability}</span>}
                  {deliveryDate}
                </div>
              </div>
            )}
            {getAddToCartButton(sparePart)}
          </>
        )}
      </div>
    </div>
  );
};
export default SparePartsKeys_ProductListItem;
